export const CAR_PRIZE_JAN_26_URL = '/sell-my-car/guides/sell-your-car-to-win-a-brand-new-jaecoo-7';
